export default __webpack_public_path__ + "static/media/empty_rs.52dedf1f.png";